import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import Switch from "react-switch";
import moment from "moment";

const ChangeTime = ({ timeTable, changeTimeTableFunc, updateTimeTableFunc, submitLoading }) => {
  const formatTime = (time) => {
    return time.slice(0, -2) + " " + time.slice(-2);
  };
  const reverseFormatTime = (time) => {
    let newTime = moment(time).format("LT");
    debugger;
    return newTime.slice(0, -3) + newTime.slice(-2);
  };

  const dateNew = "12:00PM";
  console.log("New Date", formatTime(dateNew));
  return (
    <div>
      <div className="">
        <div className="">
          <div className="row justify-content-between">
            <div className="col-md-4 col-5"></div>
            <div className="col-md-5 col-7 text-right">
              <p>The time is according to (GMT+5) </p>
            </div>
          </div>
          {timeTable &&
            timeTable.map((item) => (
              <div key={item.id} className="row justify-content-between">
                <div className="col-md-4 col-5">
                  <div className="d-flex mb-2">
                    <Switch
                      width={40}
                      height={20}
                      checked={item.is_on}
                      onChange={(e) => changeTimeTableFunc(e, item.id, item.start, item.end)}
                      className=""
                    />

                    <label className="text-left ml-3">{item.day}</label>
                  </div>
                </div>
                <div className="col-md-4 col-7">
                  <div className="d-flex text-center">
                    <ReactDatePicker
                      className="calender-container calender-container-input"
                      selected={new Date(`01/01/1970 ${formatTime(item.start)}`)}
                      onChange={(date) =>
                        changeTimeTableFunc(item.is_on, item.id, reverseFormatTime(date), item.end)
                      }
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={5}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      disabled={!item.is_on}
                    />

                    <ReactDatePicker
                      className="calender-container calender-container-input"
                      selected={new Date(`01/01/1970 ${formatTime(item.end)}`)}
                      onChange={(date) =>
                        changeTimeTableFunc(
                          item.is_on,
                          item.id,
                          item.start,
                          reverseFormatTime(date)
                        )
                      }
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={5}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      disabled={!item.is_on}
                    />
                  </div>
                </div>
              </div>
            ))}
          <div className="row justify-content-between mt-3">
            <div className="col-md-4 col-5"></div>
            <div className="col-md-4 col-7">
              <button
                disabled={submitLoading}
                className="btn btn-block btn-success"
                onClick={() => updateTimeTableFunc()}
              >
                Update Timetable
                {submitLoading && (
                  <div class="spinner-border spinner-border-sm ml-2" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeTime;
